import Link from 'next/link';
import { useRef } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import './SuperLink.scss';
import { srcSet, useDimensions } from '../../helpers/image';

export default function SuperLink({
  useQuery,
  imageUrl,
  contentImageQuery,
  link,
  prefix,
  text,
  title
}) {
  const ref = useRef();
  const dimensions = useDimensions(ref);

  const { data } = useQuery(contentImageQuery, {
    skip: imageUrl || !link,
    variables: { uri: link }
  });

  const imageSrc = imageUrl || data?.content?.imageUrl;

  if (!link) return null;

  return (
    <Link href={link}>
      <div className="superlink">
        {imageSrc && (
          <div ref={ref} className="superlink-img">
            {dimensions && (
              <LazyLoadImage
                threshold={0}
                alt="content-image"
                srcSet={srcSet(imageSrc, dimensions)}
              />
            )}
          </div>
        )}

        <div>
          <p>{prefix || 'Lees ook:'}</p>

          <span>{text || title}</span>
        </div>
      </div>
    </Link>
  );
}
